function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M24 14a4.493 4.493 0 0 0-3-4.239V9A9 9 0 0 0 3 9v.761a4.5 4.5 0 0 0 0 8.483 1.5 1.5 0 0 0 2-1.414V9a7 7 0 1 1 14 0v7.83a1.494 1.494 0 0 0 .5 1.1v.57c0 1.474-1.291 2-2.5 2h-1.778a2 2 0 1 0 0 2H17c2.65 0 4.5-1.645 4.5-4v-.478A4.5 4.5 0 0 0 24 14z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.144 14.045a.833.833 0 0 1 .7-.377.823.823 0 0 1 .454.135.833.833 0 0 1 .243 1.154 5.418 5.418 0 0 1-9.08 0 .834.834 0 0 1 1.4-.912 3.75 3.75 0 0 0 6.288 0z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.667,
  cy: 9.501,
  r: 1.667
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.333,
  cy: 9.501,
  r: 1.667
});

var SvgHeadphonesCustomerSupportHumanBold = function SvgHeadphonesCustomerSupportHumanBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default SvgHeadphonesCustomerSupportHumanBold;